<template>
  <div class="panel panel-default">
    <loading-spinner v-if="loading"></loading-spinner>

    <div v-else class="panel-body text-center" style="padding: 18px 0;">
      <span style="font-size: 48px; line-height:48px;">{{ count | number }}</span>

      <br>

      <span class="text-muted" style="font-size: 14px; line-height:14px;">Open Opportunities</span>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import store from '@/store'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'

export default {
  components: {LoadingSpinner},

  data() {
    return {
      opportunities: null,

      loading: true,
      shared: store
    }
  },

  mounted() {
    this.load()
  },

  computed: {
    count() {
      return this.opportunities.meta.total
    }
  },

  methods: {
    load() {
      http.get('/api/v2/opportunities', {'filter[status]': 'open','filter[user_id]': this.shared.user.id})
          .then(response => {
            this.opportunities = response.data

            this.loading = false
          })
    }
  }
}
</script>
